// src/utils/analytics.js

/**
 * Fire a custom GA4 event.
 * @param {string} eventName - e.g. 'EmailCapture_Submitted'
 * @param {object} params - Additional properties. e.g. { domain: 'gmail.com' }
 */
export function trackEvent(eventName, params = {}) {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, params);
    } else {
      console.log('[GA trackEvent] gtag not ready:', eventName, params);
    }
  }
  
  /**
   * Manually track a page_view in GA4 for single-page apps.
   * @param {string} path - e.g. '/landing'
   * @param {string} [title] - optional page title
   */
  export function trackPageView(path, title = '') {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: path,
        page_title: title,
      });
    } else {
      console.log('[GA trackPageView] gtag not ready:', path, title);
    }
  }
  
  /**
   * Set the user ID in GA4, e.g. after login.
   * Google recommends only calling this after you've confirmed the user's identity.
   * @param {string} userId 
   */
  export function setUserId(userId) {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('set', 'user_properties', { user_id: userId });
    } else {
      console.log('[GA setUserId] gtag not ready:', userId);
    }
  }
  
  /**
   * Set custom user properties in GA4. 
   * e.g. setUserProperties({ plan: 'premium', country: 'US' })
   */
  export function setUserProperties(properties = {}) {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('set', 'user_properties', properties);
    } else {
      console.log('[GA setUserProperties] gtag not ready:', properties);
    }
  }
  